import React from 'react'
import Image from 'next/image'
import trialContent1 from '../../public/trial_content1.png'
import trialContent2 from '../../public/trial_content2.png'

const MAP = [
  {
    image: trialContent1,
    title: 'SHElikesの紹介',
    description:
      '卒業生紹介などを含めてSHElikesのサービス概要を説明いたします。',
  },
  {
    image: trialContent2,
    title: 'カウンセリング',
    description:
      '一人一人の理想のキャリアをお伺いし、SHElikesを使ってどのように実現していくかを一緒に考えます。',
  },
]

const TrialContents = () => {
  return (
    <ol className="bg-white pt-7 mt-11 mb-11 mx-auto max-w-[600px] sm:w-auto">
      {MAP.map(({ image, title, description }, i) => (
        <li
          className="flex items-center px-[8vw] pb-8 sm:items-start sm:px-4 sm:pb-8"
          key={`${image.src}${i}`}
        >
          <div className="w-[98px] h-[90px] mr-4">
            <Image
              width={98}
              height={90}
              src={image.src}
              alt={`${title}}の画像`}
            />
          </div>
          <div className="flex-1">
            <span className="inline-block w-full text-left text-[13px] font-bold mb-1 tracking-[0.24em]">
              {title}
            </span>
            <p className="text-left text-[11px] leading-[1.8] text-gray-600">
              {description}
            </p>
          </div>
        </li>
      ))}
    </ol>
  )
}

export default TrialContents
